import { Component as ComponentDecorator, Watch } from 'vue-property-decorator';
import CVueInstance from './CVueInstance';

@ComponentDecorator({
  props: {
    colorClass: String,
    orderByField: String,
    orderByAsc: Boolean,
    serviceName: [Array, String],
    tags: Array,
    limit: Number,
    showOnlyTopProducts: Boolean,
  },
})

export default class CubeProductList extends CVueInstance {
  private Products: any[] | undefined | null = null;

  @Watch('$props', { immediate: true, deep: true })
  onPropsChanged(value: any, oldValue: any) {
    this.updateProductList();
  }

  mounted() {
    this.updateProductList();
  }

  private async updateProductList() {
    const self = this as any;
    self.Products = null;
    try {
      if (this.tools.isArray(self.serviceName)) {
        return self.getProductsFromArray(self.serviceName);
      } else if (self.serviceName === 'BetterServices') {
        return self.getProductsFromArray(['BetterFibre', 'BetterMarketing']);
      }
      self.Products = await this.GetFromFB(self.serviceName, self.limit);
    } catch (Exc) {
      console.error(Exc);
      self.Products = undefined;
    }
  }

  private async getProductsFromArray(services: string[]) {
    const self = this as any;
    const limit = Math.round(self.limit / services.length);
    let arrOfProds = [];
    for (const service of services) {
      const returnedProds = await this.GetFromFB(service, limit);
      if (!this.tools.isUndefined(returnedProds) && returnedProds.length > 0) {
        for (let retProd of returnedProds) {
          arrOfProds.push(retProd);
        }
      }
    }
    return this.Products = arrOfProds.length > 0 ? arrOfProds : undefined;
  }

  private GetFromFB(service: string, limit: Number): Promise<any[]> {
    let self = this as any;
    return new Promise((resolve, reject) => {
      let query: any = self.$firebase.firestore.collection('products').where('active', '==', true);
      if (self.showOnlyTopProducts === true) {
        query = query.where('topProduct', '==', true);
      }
      if (self.serviceName !== undefined && self.serviceName !== null) {
        query = query.where('service', '==', service);
      }
      if (self.orderByField !== undefined && self.orderByField !== null) {
        query = (self.orderByAsc !== false)
          ? query.orderBy(self.orderByField)
          : query.orderBy(self.orderByField, 'desc');
      }
      if (self.limit !== undefined && self.limit !== null) {
        query = query.limit(limit);
      }
      query.get().then((prodDocs: any) => {
        let prodList = [];

        for (const prodDoc of prodDocs.docs) {
          prodList.push(prodDoc.data());
        }

        resolve(prodList)
      }).catch((err: any) => {
        console.error(err);
        resolve(undefined)
      });
    });
  }
}
